import { Button, CircularProgress, ButtonProps } from '@mui/material';
import { ReactNode } from 'react';

const LoaderCircle = () => <CircularProgress color="inherit" size={24} value={100} />;

const FormButton = ({
    submitting = false,
    children,
    ...props
}: ButtonProps & { submitting?: boolean; children?: ReactNode }) => {
    return (
        <>
            <Button disabled={submitting} {...props} startIcon={submitting ? <LoaderCircle /> : props?.startIcon}>
                {children}
            </Button>
        </>
    );
};

export default FormButton;
